import licenseModule from '../../license.module';

export default licenseModule.component('licenseIdDetail', {
    template: require('./licenseIdDetail.component.html'),
    bindings: {
        subscription: '<',
        perpetual: '<',
        label: '<'
    }
});



// WEBPACK FOOTER //
// ./modules/license/features/license-id-detail/licenseIdDetail.component.js